import ApiService from '@api/api-service';

var VCA = VCA || {};

VCA.HospitalMobileNav = (function ($) {

    let MEDIA_QUERY = '(max-width: 991px)';
    let mql = window.matchMedia(MEDIA_QUERY);
    let elPresent = false;
    let emergencyInfoIsLoaded = false;

    function bindEvents() {
        $(window).on('resize',() => {
            if (elPresent && mql.matches) {
                $('body').css('margin','0 0 75px 0');
            } else {
                $('body').css('margin','0');
            }
        });
        $(document).on('click', checkOutsideClick);
        // $('.hospital-mobile-nav__item').on('click', toggleContainer);
    }

    // function toggleContainer(e) {
    //     let selectedItem = e.currentTarget;
    //     let contentItem = $(selectedItem).data('item');
    //     let selectedItemIsActive = $(selectedItem).hasClass('active');
    //     let contentContainer = $('.hospital-mobile-nav__content');

    //     if ((contentItem == undefined) == false) {
    //         $('.hospital-mobile-nav__item').each((index,el) => {
    //             let isActive = $(el).hasClass('active');
    //             if (el == selectedItem) {
    //                 return;
    //             } else if (isActive) {
    //                 $(el).removeClass('active');
    //             }
    //         });
    
    //         $('.hospital-mobile-nav__content-item').each((index,el) => {
    //             let id = $(el).attr('id');
    //             let isActive = $(el).hasClass('active');
    
    //             if (id == contentItem && !isActive) {
    //                 $(el).addClass('active');
    //             } else {
    //                 $(el).removeClass('active');
    //             }
    //         });
    
    //         if (selectedItemIsActive) {
    //             $(selectedItem).removeClass('active');
    //             $(contentContainer).removeClass('opened');
    //         } else {
    //             $(selectedItem).addClass('active');
    //             $(contentContainer).addClass('opened');
    //         }
    //     }
    // }

    function checkOutsideClick(e) {
        let item = $('.hospital-mobile-nav__item');
        let contentEl = $('.hospital-mobile-nav__content');
        let contentItem =  $('.hospital-mobile-nav__content-item');


        if ( $(e.target).closest(item).length === 0 && 
            $(e.target).closest(contentEl).length === 0 &&
            $(e.target).closest(contentItem).length === 0) {
            $(contentEl).removeClass('opened');

            $(item).each((index,el) => {
                if ($(el).hasClass('active')) {
                    $(el).removeClass('active')
                    $(contentEl).removeClass('opened');
                }
            });
            $(contentItem).each((index,el) => {
                if ($(el).hasClass('active')) {
                    $(el).removeClass('active')
                    $(contentEl).removeClass('opened');
                }
            });

       }
    }

    function highlightCurrentDay() {
        // Highlight the current day in hospital modal *@
        var today = new Date().toDateString().substr(0, 3);
        var dayXPath = ".//span[contains(@class, 'day') and contains(., '" + today + "')]";
        var daySpanTags = document.evaluate(dayXPath, document, null, XPathResult.ORDERED_NODE_SNAPSHOT_TYPE, null);
        for(let i=0; i<daySpanTags.snapshotLength; i++){
            var daySpanTag=daySpanTags.snapshotItem(i);
            daySpanTag.parentNode.classList.add("active");
        }
    }

    function createMobileEmergencyInfo() {
        let emergencyContainer = $('#MobileEmergencyInfoContent');
        if (!emergencyContainer.length) {
            return;
        }

        bindEmergencyBtn();
    }

    function bindEmergencyBtn() {
        $('.mobile-emergency-info').on('click', function (e) {
            e.preventDefault();
            getEmergencyModalInfo();
        });
    }

    async function getEmergencyModalInfo() {
        if (emergencyInfoIsLoaded) {
            return;
        }
        
        let emergencyContainer = $('#MobileEmergencyInfoContent');

        emergencyContainer.find('.mobile-emergency-error').remove();
        emergencyContainer.append(`
            <div class="emergency-modal__loader">
                <img src="/images-2/VCA_LoadingDog.gif" alt="Loader Icon"/>
            </div>
        `);
    
        let api = new ApiService('/emergency-api/get-emergency-modal');
        let query = {
            contextItemId: emergencyContainer.data('context-item'),
            emergencyCTAItemId: emergencyContainer.data('emergency-cta-item')
        }
        const { data, success, error } = await api.query(query);

        if (success) {
            if (data) {
                emergencyContainer.find('.emergency-modal__loader').remove();
                var phones = '';
                $.each(data.phone, function (i, item) {
                    if(i != 0) {
                        phones += `<div><a class="emergency-modal__tel" href="tel:${item}">Alt: ${item}</a></div>`;
                    }else{
                        phones += `<div><a class="emergency-modal__tel" href="tel:${item}">${item}</a></div>`;
                    }
                    
                });

                emergencyContainer.append(`
                    <img class="emergency-modal__logo" src="${data.iconUrl}" alt="Emergency Care Icon"></img>
                    <div class="emergency-modal__title">${data.title}</div>
                    ${phones}
                    <div class="emergency-modal__details">${data.message}</div>
                `);
                emergencyInfoIsLoaded = true;
            }
        } else {
            emergencyContainer.find('.emergency-modal__loader').remove();
            emergencyContainer.append(`<div class="mobile-emergency-error">${error}</div>`)
            console.log("Error retrieving emergency modal information: ", error);
        }
    }

    function init() {
        if (process.env.NODE_ENV !== 'development') {
            bindEvents();
        }
        createMobileEmergencyInfo();
        highlightCurrentDay();
    }

    return {
        init: init
    };

})(jQuery);

$(function () {
    VCA.HospitalMobileNav.init();
});